var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _circle, _path, _path2, _path3, _path4, _circle2, _circle3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _ellipse, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _ellipse2, _path46, _ellipse3, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _g16, _path60, _circle4, _circle5, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _ellipse4, _path70, _path71, _ellipse5, _g17, _path72, _path73, _path74, _path75, _path76, _circle6, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _circle7, _circle8, _path85, _path86, _path87, _path88, _g18, _path89, _path90, _path91, _path92, _ellipse6, _path93, _g19, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _circle9, _circle10, _rect, _path103, _circle11, _path104, _path105, _ellipse7, _circle12, _circle13, _path106, _path107, _g20, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _g21, _path124, _g22, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _g23, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _ellipse8, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _ellipse9, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _g24, _path183, _ellipse10, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _rect2, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _circle14, _circle15, _circle16, _circle17, _circle18, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _g25, _path234, _path235, _path236, _path237, _g26, _rect3, _rect4, _path238, _path239, _path240, _path241, _path242, _g27, _path243, _g28, _g29, _path244, _path245, _rect5, _g30, _path246, _path247, _path248;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUntitled3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1281 165.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5b7fc0;}.cls-2{fill:#da513e;}.cls-3{fill:#ebebeb;}.cls-4{fill:#91b2dd;}.cls-5{fill:#e6c1a9;}.cls-6{fill:#dddfe0;}.cls-7{fill:#eca880;}.cls-8{fill:#a9d8b5;}.cls-9{fill:#d4e1f3;}.cls-10{fill:#55a55c;}.cls-11{fill:#fdd663;}.cls-12,.cls-13,.cls-14,.cls-25,.cls-27,.cls-29,.cls-30,.cls-32,.cls-37,.cls-38,.cls-39,.cls-40,.cls-42,.cls-48,.cls-54,.cls-56,.cls-60,.cls-62,.cls-67,.cls-72,.cls-74,.cls-81,.cls-82,.cls-83{fill:none;}.cls-12,.cls-13,.cls-14,.cls-30,.cls-47,.cls-56,.cls-70{stroke:#d4e1f3;}.cls-12,.cls-13,.cls-14,.cls-27,.cls-29,.cls-30,.cls-40,.cls-47,.cls-56,.cls-62,.cls-70,.cls-82,.cls-83{stroke-linecap:round;}.cls-13{stroke-linejoin:round;}.cls-14{stroke-width:1.68px;}.cls-15{fill:#d48e64;}.cls-16{fill:#f2bd41;}.cls-17{fill:#f19920;}.cls-18{fill:#ce835a;}.cls-19{fill:#674424;}.cls-20{fill:#c2c1c0;}.cls-21{fill:#98705b;}.cls-22{fill:#a42422;}.cls-23{fill:#f2f3f4;}.cls-24{mask:url(#mask);}.cls-25{stroke:#3868b2;}.cls-26{fill:#deb093;}.cls-27{stroke:#b22024;}.cls-28{mask:url(#mask-2);}.cls-29,.cls-67{stroke:#b8332a;}.cls-30,.cls-33,.cls-48,.cls-62,.cls-64{isolation:isolate;}.cls-30,.cls-33,.cls-62{opacity:0.5;}.cls-31{mask:url(#mask-3);}.cls-32{stroke:#d98758;}.cls-33{fill:#d98758;}.cls-34{fill:#cb6229;}.cls-35{fill:#81c995;}.cls-36{mask:url(#mask-4);}.cls-37{stroke:#5bb874;}.cls-38{stroke:#7198cf;}.cls-39{stroke:#a5a4a4;}.cls-39,.cls-40{stroke-width:0.91px;}.cls-40{stroke:#787878;}.cls-41{fill:#7198cf;}.cls-42,.cls-48{stroke:#547dbf;}.cls-43{fill:#91b2de;}.cls-44{fill:#6b6b6b;}.cls-45{fill:#a25a4b;}.cls-46{fill:#372422;}.cls-47,.cls-69,.cls-70{fill:#fff;}.cls-47,.cls-56,.cls-83{stroke-width:2px;}.cls-48,.cls-64{opacity:0.25;}.cls-49{mask:url(#mask-5);}.cls-50{fill:#208e45;}.cls-51{fill:#f7ab1b;}.cls-52{mask:url(#mask-6);}.cls-53{fill:#34a851;}.cls-54{stroke:#1a8140;}.cls-55{mask:url(#mask-7);}.cls-57{fill:#873f32;}.cls-58{fill:#18733b;}.cls-59{mask:url(#mask-8);}.cls-60{stroke:#18733b;}.cls-61{fill:#842d1b;}.cls-62{stroke:#55a55c;}.cls-63{fill:#c24739;}.cls-64{fill:#9a9fa5;}.cls-65{fill:#e8976f;}.cls-66{mask:url(#mask-9);}.cls-68{fill:#b1c9e9;}.cls-71{mask:url(#mask-10);}.cls-72{stroke:#f9bc15;}.cls-73{mask:url(#mask-11);}.cls-74{stroke:#dddfe0;}.cls-75{fill:#ed675c;}.cls-76{fill:#f7aea9;}.cls-77{mask:url(#mask-12);}.cls-78{mask:url(#mask-13);}.cls-79{mask:url(#mask-14);}.cls-80{mask:url(#mask-15);}.cls-81{stroke:#d3987a;}.cls-82{stroke:#3f70b7;}.cls-83{stroke:#3768b2;}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 961.71,
    y: 43.44,
    width: 31.66,
    height: 23.66,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -13.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M984.21,56.8a34.28,34.28,0,0,0-10,1.08,12.48,12.48,0,0,0-2.59,1l-10.93,5.74,4.94,10.27,10.55-2.64,4.42,7.52,11.75-4.49L986.5,58.45A2.52,2.52,0,0,0,984.21,56.8Z"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 941.4,
    y: 5.74,
    width: 63.62,
    height: 42.83,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -13.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M957.82,26.23l-14.51-7.16-2.91,5.28s9.78,5.51,14.1,8.47c4,2.74,7.07,7.84,8.88,12.09S965,55.35,965,55.35c3-3,5.72-3.76,10.45-2.23a28,28,0,0,0,10,1l-1.09-5.75,16.36,13.54,3.34-3.49-18.61-20a8.2,8.2,0,0,0-3.08-2.08l-2.93-1.12c0,.17-.36.78-.42,1-.93,2.52-3.18,3.74-5,3s-2.58-3.32-1.65-5.7c0,0,.32-.55.4-.71Z"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 1147.54,
    y: 134.43,
    width: 19.04,
    height: 31.24,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -13.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1163.48,150.09l-4.22,18.17a2.12,2.12,0,0,0,1,2.31l4.52,2.68a1.42,1.42,0,0,1,.65,1.59,1.4,1.4,0,0,1-1.37,1h-13l-4.45-25.74Z"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 1152.98,
    y: 78.22,
    width: 24.87,
    height: 26.91,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -13.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1175.69,98.61a16.79,16.79,0,0,0-2.37-5.52,4.28,4.28,0,0,1-7.39,2,4.16,4.16,0,0,1-1-3.53A8.75,8.75,0,0,0,1159,95c-3.23,4.39-4.07,10.81-7,18.15l15,5.32a6.07,6.07,0,0,1,1.77-4.2l2.06,2.3,6.06-5.64-3.26-3.41A11.35,11.35,0,0,0,1175.69,98.61Z"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 1173.91,
    y: 93.54,
    width: 45.02,
    height: 34.69,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -13.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1217.67,116.59l-10.06,15.06a2.88,2.88,0,0,1-4.18.61l-1.69-1.39v4.33h-6.61l-3.9,6.36-16.12-8.73a4.22,4.22,0,0,1-1.29-6.31L1187,110c2.29-2.58,4.22-2.88,4.91-2.9a1.4,1.4,0,0,1,.29,0l.25.07,5.1,1.57a6.6,6.6,0,0,1,1.74.82.45.45,0,0,1,.14.1,6.28,6.28,0,0,1,2.1,2.47c2.07,4.44,3.29,11.46,3.29,11.46l7.23-10.69Z"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 909.91,
    y: 123.96,
    width: 27.39,
    height: 39.14,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -13.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M936.22,150.21c-.32-7.39-4.69-12.49-8.17-12.49a8.62,8.62,0,0,0-5.39,1.66l-.54,1.44h-6.57s-3.33,8.78-5.29,13.38-2,9.33,1.26,9.33a7.24,7.24,0,0,0,3.24-.94,21,21,0,0,0,7.16,13.66C936.64,176.25,936.55,157.58,936.22,150.21Z"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 917.62,
    y: 116.49,
    width: 10.47,
    height: 12.59,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -13.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M919.66,131l.33,1.91a1.65,1.65,0,0,0,1.87,1.23l4.06-.58a1.09,1.09,0,0,1,1.14.84,1.11,1.11,0,0,1-.53,1.22l-3.26,1.78-1.15,3.43h-5.5l.71-5.24a7.82,7.82,0,0,1,2-4.27Z"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 211.83,
    y: 104.97,
    width: 50.71,
    height: 43.97,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -13.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M261.14,136a7.7,7.7,0,0,0-3.45-6.71c-3.53-2.34-9.1-6-14-9.1-4-2.51-7.13-2.07-9.26-1a9,9,0,0,0-4,4.1l-19.57,39h9.55l19.83-28.1a40.8,40.8,0,0,0,12.54,3.07l.81,7.54h8Z"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    x: 330.33,
    y: 75.76,
    width: 19.59,
    height: 35.67,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -13.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.92,124.75l-17.09-2.41s-6-14.3.56-23.78l-1.61-4.17,8.86-5.3s8,10.12,9.28,35.67"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    x: 106.2,
    y: 93.67,
    width: 34.65,
    height: 25,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -13.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M128.88,107.7A5,5,0,0,1,119,108h-3.3a16.8,16.8,0,0,0-7.21,2.43,7.64,7.64,0,0,0,0,12.62,7.27,7.27,0,0,0,3.18,1.12s.36,5.31-1.14,7.8h17.77l11.34-24.28Z"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    x: 88.24,
    y: 117.66,
    width: 40.3,
    height: 31,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -13.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.47,132s-7.89.21-10.57,7.08-2.66,14.56-2.66,22.22h6.64s.41-10.49,2.27-14.67c0,0,2.52-7.34,12.87-5.31l8.36-9.35Z"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    x: 115.84,
    y: 93.29,
    width: 43.6,
    height: 51.38,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -13.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.86,106.62a8.34,8.34,0,0,1-13.23,1.92c-2.63,1.27-5.52,3.6-6,7.78v15.25h-5.58s-6.67,1.5-8.81,8-2.41,13.29-2.41,18.15h22.37s-.49-9.83,3.63-16.26h6.56c6.41,0,9.43-8.55,10.28-13.51C159,120.52,159,109.37,150.86,106.62Z"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    x: 142.18,
    y: 107.97,
    width: 14.86,
    height: 9.98,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -13.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.18,128.09l1.88,2.75c7.86,0,11.48-6.52,12.32-8.29h-5.6C147.78,126.8,141.18,128.09,141.18,128.09Z"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    x: 139.61,
    y: 78.1,
    width: 10.97,
    height: 9.39,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -13.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask13"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 145.77,
    cy: 95.24,
    r: 3.8
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    x: 118.89,
    y: 142.74,
    width: 17.74,
    height: 21.66,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -13.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M128.82,157.7h-1.27c.29-3.65-.09,0-.09,0h-6.74c.13,4.7,1.3,9.55,2.07,14.53a1.44,1.44,0,0,1-.93,1.51l-3.46,1.51a.82.82,0,0,0,.32,1.58h12.37a1.44,1.44,0,0,0,1.42-1.42,107.2,107.2,0,0,1,2-17.67Z"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mask14-2",
    "data-name": "mask14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M128.82,158h-1.3c.28-3.63-.09,0-.09,0h-6.7c.13,4.67,1.29,9.48,2.07,14.43a1.48,1.48,0,0,1-.94,1.51l-3.43,1.49a.82.82,0,0,0,.32,1.57H131a1.49,1.49,0,0,0,1.48-1.48,113,113,0,0,1,2.1-18.52Z",
    transform: "translate(1 -13.33)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "mask13-2",
    "data-name": "mask13"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 146.77,
    cy: 81.91,
    r: 3.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "mask12-2",
    "data-name": "mask12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.18,128.54l1.88,2.75c7.86,0,11.48-6.52,12.32-8.29h-5.6C147.78,127.24,141.18,128.54,141.18,128.54Z",
    transform: "translate(1 -13.33)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "mask11-2",
    "data-name": "mask11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.91,107.74a8.19,8.19,0,0,1-13,1.89c-2.58,1.24-5.43,3.54-5.89,7.66V132h-5.55s-6.64,1.49-8.77,7.94-2.39,13.22-2.39,18.06h22.19s-.48-9.67,3.58-16h6.45c6.3,0,9.27-8.42,10.11-13.29C158.89,121.41,158.88,110.44,150.91,107.74Z",
    transform: "translate(1 -13.33)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "mask10-2",
    "data-name": "mask10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.49,132s-7.8.21-10.45,7-2.63,14.39-2.63,22H94s.41-10.36,2.25-14.5c0,0,2.49-7.25,12.72-5.25l8.27-9.25Z",
    transform: "translate(1 -13.33)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "mask9-2",
    "data-name": "mask9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M128.88,107c-.32,3.12-2.35,5-4.79,5s-5-4-5-4h-3.29a16.68,16.68,0,0,0-7.22,2.44,7.65,7.65,0,0,0,0,12.63,7.15,7.15,0,0,0,3.19,1.12s.36,5.32-1.15,7.81h17.6l11.67-25Z",
    transform: "translate(1 -13.33)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "mask8-2",
    "data-name": "mask8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.92,124.75l-17.09-2.41s-6-14.3.56-23.78l-1.61-4.17,8.86-5.3s8,10.12,9.28,35.67",
    transform: "translate(1 -13.33)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "mask7-2",
    "data-name": "mask7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M260.45,136.42a7.5,7.5,0,0,0-3.36-6.52c-3.44-2.28-8.85-5.82-13.65-8.85-3.88-2.43-6.93-2-9-1a8.81,8.81,0,0,0-3.88,4l-19,37.93h9.29l19.27-27.32a39.46,39.46,0,0,0,12.19,3l.78,7.34h7.77Z",
    transform: "translate(1 -13.33)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "mask6-2",
    "data-name": "mask6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M919.66,131.17l.33,1.91a1.65,1.65,0,0,0,1.87,1.23l4.06-.58a1.09,1.09,0,0,1,1.14.84,1.11,1.11,0,0,1-.53,1.22l-3.26,1.78L922.12,141h-5.5l.71-5.24a7.78,7.78,0,0,1,2-4.27Z",
    transform: "translate(1 -13.33)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "mask5-2",
    "data-name": "mask5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M936.22,150.38c-.32-7.38-4.69-12.49-8.17-12.49a8.63,8.63,0,0,0-5.39,1.67l-.54,1.44h-6.57s-3.33,8.77-5.29,13.38-2,9.33,1.26,9.33a7.37,7.37,0,0,0,3.24-.94,21,21,0,0,0,7.16,13.66C936.64,176.43,936.55,157.76,936.22,150.38Z",
    transform: "translate(1 -13.33)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "mask4-2",
    "data-name": "mask4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1217.93,116.39l-10.06,15.06a2.86,2.86,0,0,1-4.18.6l-1.69-1.38V135h-6.61l-3.9,6.36-16.12-8.74a4.21,4.21,0,0,1-1.29-6.31l13.15-16.54c2.29-2.57,4.22-2.87,4.91-2.89a.71.71,0,0,1,.29,0l.25.07,5.1,1.57a6.57,6.57,0,0,1,1.74.81.71.71,0,0,1,.14.1,6.31,6.31,0,0,1,2.1,2.48c2.07,4.44,3.29,11.46,3.29,11.46l7.23-10.69Z",
    transform: "translate(1 -13.33)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "mask3-2",
    "data-name": "mask3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1175.69,98.61a16.79,16.79,0,0,0-2.37-5.52,4.28,4.28,0,0,1-7.39,2,4.16,4.16,0,0,1-1-3.53A8.75,8.75,0,0,0,1159,95c-3.23,4.39-4.07,10.81-7,18.15l15,5.32a6.07,6.07,0,0,1,1.77-4.2l2.06,2.3,6.06-5.64-3.26-3.41A11.35,11.35,0,0,0,1175.69,98.61Z",
    transform: "translate(1 -13.33)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "mask2-2",
    "data-name": "mask2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1163.55,150l-4.26,18.36a2.15,2.15,0,0,0,1,2.33l4.57,2.71a1.42,1.42,0,0,1-.73,2.65H1151l-4.49-26Z",
    transform: "translate(1 -13.33)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "mask1-2",
    "data-name": "mask1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M957.82,26.23l-14.51-7.16-2.91,5.28s9.78,5.51,14.1,8.47c4,2.74,7.07,7.84,8.88,12.09S965,55.35,965,55.35c3-3,5.72-3.76,10.45-2.23a28,28,0,0,0,10,1l-1.09-5.75,16.36,13.54,3.34-3.49-18.61-20a8.2,8.2,0,0,0-3.08-2.08l-2.93-1.12c0,.17-.36.78-.42,1-.93,2.52-3.18,3.74-5,3s-2.58-3.32-1.65-5.7c0,0,.32-.55.4-.71Z",
    transform: "translate(1 -13.33)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "mask0-2",
    "data-name": "mask0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M984.21,56.8a34.28,34.28,0,0,0-10,1.08,12.48,12.48,0,0,0-2.59,1l-10.93,5.74,4.94,10.27,10.55-2.64,4.42,7.52,11.75-4.49L986.5,58.45A2.52,2.52,0,0,0,984.21,56.8Z",
    transform: "translate(1 -13.33)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1121.51,
    cy: 75.24,
    r: 27.66
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1120.5,75.5v88",
    transform: "translate(1 -13.33)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1120.08,94.92l10.3-10.3",
    transform: "translate(1 -13.33)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1119.89,104.82l-7.33-7.32",
    transform: "translate(1 -13.33)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1119.89,88.76l-7.33-7.32",
    transform: "translate(1 -13.33)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1132.79,
    cy: 81.59,
    r: 1.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1105.21,
    cy: 68.1,
    r: 1.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1100.76,168.63a13.6,13.6,0,0,1,25.67,6.25",
    transform: "translate(1 -13.33)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1087.3,174.88a7.89,7.89,0,1,1,15.77,0",
    transform: "translate(1 -13.33)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1123.18,166.07a9.59,9.59,0,0,1,13.36,8.81",
    transform: "translate(1 -13.33)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1113.5,165.5v8.37l-4.09-4.09",
    transform: "translate(1 -13.33)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1113.59,170.94l3-3",
    transform: "translate(1 -13.33)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M967.07,169.63a13.6,13.6,0,0,1,25.67,6.25",
    transform: "translate(1 -13.33)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1000.51,169.52a13.59,13.59,0,0,1,25.66,6.25",
    transform: "translate(1 -13.33)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M953.62,175.88a7.88,7.88,0,1,1,15.76,0",
    transform: "translate(1 -13.33)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M942.87,175.88a7.88,7.88,0,0,1,12.91-6.07",
    transform: "translate(1 -13.33)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1026.17,175.88a7.89,7.89,0,1,1,15.76,0",
    transform: "translate(1 -13.33)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M989.49,167.07a9.59,9.59,0,0,1,13.36,8.81",
    transform: "translate(1 -13.33)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M969.5,116.5v50",
    transform: "translate(1 -13.33)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M979.5,166.5v8.37l-4.09-4.09",
    transform: "translate(1 -13.33)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1011.5,166.5v8.37l-4.1-4.09",
    transform: "translate(1 -13.33)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M969.51,135.54,976,129",
    transform: "translate(1 -13.33)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M969.38,126.49l-4.62-4.63",
    transform: "translate(1 -13.33)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M979.9,171.94l3-3",
    transform: "translate(1 -13.33)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M959.5,128.5V115.9a10,10,0,0,1,10-10h0a10,10,0,0,1,10,10v18.76a10,10,0,0,1-10,10h0a10,10,0,0,1-5.18-1.44",
    transform: "translate(1 -13.33)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M953.5,133.5v35",
    transform: "translate(1 -13.33)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M953.62,148.76l6.5-6.5",
    transform: "translate(1 -13.33)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M953.5,140.46l-4.62-4.62",
    transform: "translate(1 -13.33)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M953.5,127.17h0a10,10,0,0,1,10,10V145a10,10,0,0,1-10,10h0a10,10,0,0,1-10-10v-7.78A10,10,0,0,1,953.5,127.17Z",
    transform: "translate(1 -13.33)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M980,117h17v19",
    transform: "translate(1 -13.33)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M944,97h27v7",
    transform: "translate(1 -13.33)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M997,136h27v19",
    transform: "translate(1 -13.33)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1024,155h27v21",
    transform: "translate(1 -13.33)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1051,176h27",
    transform: "translate(1 -13.33)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M971,98v5",
    transform: "translate(1 -13.33)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1087.45,93.78s-9,.33-19.8,0a30.93,30.93,0,0,1-16-4.91,5.61,5.61,0,0,1-1.87-1.59c-.55-1.32-1.81,5.83-3.19,5.45L1043,95.56l-10-2.36,9.16,11.58s-.45-.67,11.57-2.68c10.51-1.77,25.13-2.52,34.23-2.65Z",
    transform: "translate(1 -13.33)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1087.73,94l7.27-.11,0,3-7,1.13Z",
    transform: "translate(1 -13.33)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 1095.33,
    cy: 96.71,
    rx: 3.05,
    ry: 3.79,
    transform: "matrix(0.09, -1, 1, 0.09, 899.23, 1165.16)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1049,92.93l-6.91-17.38L1039,79.84a3.64,3.64,0,0,0-.3.46,5,5,0,0,0,2.65,7l.78.31.81,8Z",
    transform: "translate(1 -13.33)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1017.49,71.28s6.25,6.55,14.16,13.83a30.87,30.87,0,0,0,14.92,7.66,5.59,5.59,0,0,0,2.44.16c1.32-.56,4.32,5.82,5.59,6.5l3.3,3.62,3.06,8.25L1046.22,118a98.58,98.58,0,0,0-10.38-17.13c-6.3-8.58-16.26-19.32-22.7-25.75Z",
    transform: "translate(1 -13.33)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1060.44,172.21l5.54-3.45,2.48,4.9-7,.42Z",
    transform: "translate(1 -13.33)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1046,140.16l.1-23.36a2.77,2.77,0,0,1,.62-1.75c1.32-1.66,4.93-5,12.08-4.63a3,3,0,0,1,2,.88l15.84,15.92Z",
    transform: "translate(1 -13.33)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1077.07,127.6c1,2.29-5.07,7.09-13.51,10.73s-16.32,4.58-17.3,2.29,5.28-6.93,13.73-10.57S1076.08,125.34,1077.07,127.6Z",
    transform: "translate(1 -13.33)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1101.86,126.92l-8.64,1,2.06-4.3,6.86,1.65Z",
    transform: "translate(1 -13.33)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1094.64,123.94l-19,10.2-2.7-4.42a59.47,59.47,0,0,0-8.68,2.93l8,9.25a3.63,3.63,0,0,0,5.09.41L1096.05,126a1.28,1.28,0,0,0-1.41-2.09Z",
    transform: "translate(1 -13.33)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1067.42,173.33a1,1,0,1,0,2.06-.4L1061,134.19a54.61,54.61,0,0,0-8.7,5.35Z",
    transform: "translate(1 -13.33)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1071.11,126.65l-1.37.24a46.93,46.93,0,0,0-8.21,2.52l2.79,3.24a59.47,59.47,0,0,1,8.68-2.93Z",
    transform: "translate(1 -13.33)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1050.3,135.32l1.21,2.66.75,1.56a54.61,54.61,0,0,1,8.7-5.35l-1-4.14A55.47,55.47,0,0,0,1050.3,135.32Z",
    transform: "translate(1 -13.33)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1042.1,75.55l3.18,8a113.7,113.7,0,0,1,1.78,16.35c0,8,10.09,15.8,17.75,6s-14-31.37-14-31.37-5.64-3.27-8.78,1",
    transform: "translate(1 -13.33)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 1045.15,
    cy: 82.86,
    rx: 1.73,
    ry: 1.42,
    transform: "translate(128.08 575.85) rotate(-33.41)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1017.49,71.28l-5.14-5.14-2.14,2.13,4.23,5.69Z",
    transform: "translate(1 -13.33)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 1009.83,
    cy: 67.92,
    rx: 3.05,
    ry: 3.79,
    transform: "translate(323.57 797.59) rotate(-51.08)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1058.6,173.81l2.34-1.44,1.34.37a7.07,7.07,0,0,0,1.89.26h4.76a1.44,1.44,0,0,1-.06,1.35,1.41,1.41,0,0,1-1.18.65h-8.51C1058.57,175,1058.07,174.13,1058.6,173.81Z",
    transform: "translate(1 -13.33)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1104.65,126.67l-2.79.25-.7-.45a6.61,6.61,0,0,0-1.66-.77l-5.19-1.58a1.52,1.52,0,0,1,2-1.72l8.57,2.61a.83.83,0,0,1,.59.92A.87.87,0,0,1,1104.65,126.67Z",
    transform: "translate(1 -13.33)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M988,24.51V48.78c0,2.12-3-2.44-5.06-2.55L968.8,51.65,984.69,25Z",
    transform: "translate(1 -13.33)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M974.51,22.73l-5.63,8.7,4.32,3.79,3.58-8.55Z",
    transform: "translate(1 -13.33)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M979.41,35.21l1.13,4.09-7.43,2.38-3-5.22,2.63-3.7,4.94-8.34a3.43,3.43,0,0,1,4.69-1.22l5,2.91s-2.86,7.5-5.78,8.25a2.48,2.48,0,0,1-1.65-.22Z",
    transform: "translate(1 -13.33)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M965,55.35s-.19,3.45,3.13,3.72a14.62,14.62,0,0,0,6.9-1.61l-3.79-5.13s-2.75-1.22-6.23,2.26",
    transform: "translate(1 -13.33)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M970.16,51.84,973.23,61l13.27-1.75-1.4-6.93Z",
    transform: "translate(1 -13.33)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M997.22,116.8l6.61-6.73c1-1,1.48-1.63.93-2.61l-1.76-3.17v-.09l-6,2.66-1.8,8.82a1.19,1.19,0,0,0,2,1.12Z",
    transform: "translate(1 -13.33)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M960,92,955.24,95a1.09,1.09,0,0,0,.56,2h10.48a1.31,1.31,0,0,0,1-.5,1.32,1.32,0,0,0,.23-1.09L966.75,92H960Z",
    transform: "translate(1 -13.33)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M962.36,74.68l2.46-1.2L960.74,65l-7,3.67a4,4,0,0,0-1.87,5.13L955,81h8.86Z",
    transform: "translate(1 -13.33)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M954.92,81,960,93h6.62l-2.83-12Z",
    transform: "translate(1 -13.33)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M992.37,75.28l-10.15,3.88,7.7,14.89,7.86-3.34Z",
    transform: "translate(1 -13.33)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1002.5,104.2l-4.72-13.49-7.86,3.34,6.62,12.81Z",
    transform: "translate(1 -13.33)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M984.21,56.8a34.28,34.28,0,0,0-10,1.08,12.48,12.48,0,0,0-2.59,1l-10.93,5.74,4.94,10.27,10.55-2.64,4.42,7.52,11.75-4.49L986.5,58.45A2.52,2.52,0,0,0,984.21,56.8Z",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M971.52,65l8.67,15.19",
    transform: "translate(1 -13.33)"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M982.22,79.16l.75,1.45,10.77-1.45-1.37-3.88Z",
    transform: "translate(1 -13.33)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 964.71,
    cy: 81.24,
    r: 1.07
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 1001.77,
    cy: 94.52,
    r: 1.07
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M956.94,94.49l.53.89",
    transform: "translate(1 -13.33)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M958.58,93.54l.53.88",
    transform: "translate(1 -13.33)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M995.54,111.6l1,0",
    transform: "translate(1 -13.33)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M996,109.37l1,0",
    transform: "translate(1 -13.33)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M985.61,54.89a36,36,0,0,1-8.36.41,8.38,8.38,0,0,0-5.55,1.16l-1.35-4-1.09-2.57,15.6,1.17Z",
    transform: "translate(1 -13.33)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M960,92l-.61-1H961a3.54,3.54,0,0,1,1.81,1Z",
    transform: "translate(1 -13.33)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M996.54,106.86l-.67-1.29,1.41-.61a1.94,1.94,0,0,1,2.21.58Z",
    transform: "translate(1 -13.33)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M979.93,34.14,976.18,32l2.76,4.3Z",
    transform: "translate(1 -13.33)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M988.32,24.51c-.37,3.87-4.74,1.92-8,1.92-1.86,0-4.53,1.16-5.35,2.56-.64,1.09-2.27-.78-2.27-2.14,0-3.21,4.64-8.5,9.43-8.5C985.42,18.33,988.67,21.29,988.32,24.51Z",
    transform: "translate(1 -13.33)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 978.63,
    cy: 26.25,
    rx: 1.48,
    ry: 1.08,
    transform: "translate(845.64 982.68) rotate(-83.67)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M943.31,19.07l-11-5.74a1.66,1.66,0,0,0,.25,2L936.3,19l.11.48a2.86,2.86,0,0,0,1.42,2L941,23.28Z",
    transform: "translate(1 -13.33)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1004.07,58.44l6.2,6.33-2.75,2.58-6.27-6Z",
    transform: "translate(1 -13.33)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1008.53,
    cy: 66.87,
    rx: 2.79,
    ry: 3.18,
    transform: "translate(249.11 719.39) rotate(-45)"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M957.82,26.23l-14.51-7.16-2.91,5.28s9.78,5.51,14.1,8.47c4,2.74,7.07,7.84,8.88,12.09S965,55.35,965,55.35c3-3,5.72-3.76,10.45-2.23a28,28,0,0,0,10,1l-1.09-5.75,16.36,13.54,3.34-3.49-18.61-20a8.2,8.2,0,0,0-3.08-2.08l-2.93-1.12c0,.17-.36.78-.42,1-.93,2.52-3.18,3.74-5,3s-2.58-3.32-1.65-5.7c0,0,.32-.55.4-.71Z",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M988.82,52.75,982.18,47",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M964.41,51.31s-1.81-12.17,2.37-18.71",
    transform: "translate(1 -13.33)"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1241.2,51.86a4,4,0,1,0,8,0",
    transform: "translate(1 -13.33)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1269.5,121.5v16",
    transform: "translate(1 -13.33)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1245.5,43.5V35.68a12.5,12.5,0,1,1,25-.16v56",
    transform: "translate(1 -13.33)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1261.1,174.93l1.58-30.17a7.63,7.63,0,0,1,7.63-7.24h0a7.62,7.62,0,0,1,7.61,7.24l1.58,30.17",
    transform: "translate(1 -13.33)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1255.1,52.5h-19.78a9,9,0,0,1,9-9h1.77a9,9,0,0,1,9,9h0Z",
    transform: "translate(1 -13.33)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1257.3,
    cy: 92.82,
    r: 20.57
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1236.13,101.38a20.51,20.51,0,1,1,10.29-13.76",
    transform: "translate(1 -13.33)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1255.5,97.5v78",
    transform: "translate(1 -13.33)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1256,110.87l7.66-7.65",
    transform: "translate(1 -13.33)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1255.84,118.23l-5.45-5.44",
    transform: "translate(1 -13.33)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1255.84,106.29l-5.45-5.44",
    transform: "translate(1 -13.33)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1225.5,80.5v93",
    transform: "translate(1 -13.33)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1226,87.92l7.66-7.65",
    transform: "translate(1 -13.33)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1225.83,83.34l-5.45-5.45",
    transform: "translate(1 -13.33)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1234.63,
    cy: 58.51,
    r: 1.7
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1246.31,
    cy: 93.13,
    r: 1.7
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1174.5,175.5h28",
    transform: "translate(1 -13.33)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1208.5,175.5h35",
    transform: "translate(1 -13.33)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1142.5,175.5h21",
    transform: "translate(1 -13.33)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1149.22,115.38c-12.89,10.59-9.91,34.62-9.91,34.62H1166V129.88c0-4.46.45-9.49,1.32-11.49l-12.68-8.24A49.57,49.57,0,0,1,1149.22,115.38Z",
    transform: "translate(1 -13.33)"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1163.55,150l-4.26,18.36a2.15,2.15,0,0,0,1,2.33l4.57,2.71a1.42,1.42,0,0,1-.73,2.65H1151l-4.49-26Z",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1156.45,147.78l-1,23,5.64,3.44a2.28,2.28,0,0,1-1.19,4.24H1149",
    transform: "translate(1 -13.33)"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1147.65,154h14.52l.94-4H1147Z",
    transform: "translate(1 -13.33)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1166,87.31s-2.36-8.51,6.06-10.65,10.73,7,11.6,11.66,13.49,17.15,2.69,22.65-14.35-2.58-16.11-6.19S1166,87.31,1166,87.31Z",
    transform: "translate(1 -13.33)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1184.22,96.19l28.41,8.23a2.75,2.75,0,0,1-3,1.36l-2.34-.51-2.88.71a4.43,4.43,0,0,1-1.85.06l-20.19-3.58Z",
    transform: "translate(1 -13.33)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1164.88,91.57l1.3-3.18A11.66,11.66,0,0,1,1168,86.6c2.33-1.85,2.34-.35,3.33-1.76.6-.86,2.35-1.12,3.32-1.52l4.25-1.77a20.24,20.24,0,0,1-2.55,6.68,3.55,3.55,0,0,1-4.05,1.36l-.79-.3-1.31,2.78,4.53,1.51L1172,101l-7.7-3.58-.18-4.34.76-1.46",
    transform: "translate(1 -13.33)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1171.17,
    cy: 85.14,
    rx: 1.61,
    ry: 1.17,
    transform: "translate(940.71 1223.03) rotate(-82.79)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1173.33,93.09l11.89,3.06-1.55,7.62-9.45-2.57-.93-6.1",
    transform: "translate(1 -13.33)"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1175.69,98.61a16.79,16.79,0,0,0-2.37-5.52,4.28,4.28,0,0,1-7.39,2,4.16,4.16,0,0,1-1-3.53A8.75,8.75,0,0,0,1159,95c-3.23,4.39-4.07,10.81-7,18.15l15,5.32a6.07,6.07,0,0,1,1.77-4.2l2.06,2.3,6.06-5.64-3.26-3.41A11.35,11.35,0,0,0,1175.69,98.61Z",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1173.94,107.23l-4.1-4.7",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1168.36,115l-6.11-6.85s-3.07-3.48-2.93-5.91",
    transform: "translate(1 -13.33)"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1171.55,89.29l-3.29-1.22,2.26,3.41Z",
    transform: "translate(1 -13.33)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1211,172.5h18",
    transform: "translate(1 -13.33)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1210,170.9a1.1,1.1,0,0,0,1.1,1.1h10.26a1,1,0,0,0,.91-.68,1,1,0,0,0-.38-1.07l-6.49-3.25h-6.35Z",
    transform: "translate(1 -13.33)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1216.3,170.9a1.11,1.11,0,0,0,1.1,1.1h10.24a1,1,0,0,0,.9-.68,1,1,0,0,0-.39-1.07l-6.47-3.25h-6.36Z",
    transform: "translate(1 -13.33)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1214.63,166.69l1,3.92a1,1,0,0,0,1.15.86",
    transform: "translate(1 -13.33)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1224.79,169.12l.76-.92",
    transform: "translate(1 -13.33)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1193,135h13.45a8.73,8.73,0,0,1,8.46,6.48l7.15,25.52h-13.21l-6-18h-11.7a9.09,9.09,0,0,1-9.1-9.1V136h11",
    transform: "translate(1 -13.33)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1214.59,166.44l-7.41-22.94H1205",
    transform: "translate(1 -13.33)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1223.08,168.26l.89-1",
    transform: "translate(1 -13.33)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-43",
    cx: 1209.76,
    cy: 157.76,
    r: 4.06
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 1209.76,
    cy: 157.76,
    r: 1.59
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 1214.59,
    y: 104.45,
    width: 8.7,
    height: 1.93,
    transform: "translate(658.17 1178.97) rotate(-67.61)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1212.23,113.8l2.13-3.2,3.74,2.07-1.86,3.5Z",
    transform: "translate(1 -13.33)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 1218.45,
    cy: 98.31,
    r: 3.26
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1202.64,99.38c-1.18,4-2.92,7.4-6.78,6.76s-6.87-3.32-6.18-7.48a7.38,7.38,0,0,1,8.25-6.36C1202.87,93.13,1203.49,96.53,1202.64,99.38Z",
    transform: "translate(1 -13.33)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1198.61,110.37l.56-3.37h.11a3.21,3.21,0,0,0,1.56-.21,3.8,3.8,0,0,0,2.33-3.44,18.59,18.59,0,0,0-.25-5.62l-.4-.06a3.85,3.85,0,0,0-4.39,3l-.3,1.45-3.92-.48-1,3.15-.83,3.92-.53,4.22,7.23,1.21Z",
    transform: "translate(1 -13.33)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-45",
    cx: 1195.39,
    cy: 102.46,
    rx: 1.94,
    ry: 1.65,
    transform: "translate(899.26 1251.52) rotate(-80.56)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-47",
    cx: 1189.48,
    cy: 141.88,
    r: 19.93
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-43",
    cx: 1189.48,
    cy: 141.88,
    r: 2.83
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1192.77,134.19l5.17,2.83a3.07,3.07,0,0,1,1.46,1.67,7.65,7.65,0,0,1,.39,3.36,2.08,2.08,0,0,1-1,1.56l-.34.21a2.12,2.12,0,0,1-3.17-1.46l-.28-1.66-5.09-2.15Z",
    transform: "translate(1 -13.33)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1190.45,117.11l-8.26,11.27,12.62,7.35",
    transform: "translate(1 -13.33)"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1217.93,116.39l-10.06,15.06a2.86,2.86,0,0,1-4.18.6l-1.69-1.38V135h-6.61l-3.9,6.36-16.12-8.74a4.21,4.21,0,0,1-1.29-6.31l13.15-16.54c2.29-2.57,4.22-2.87,4.91-2.89a.71.71,0,0,1,.29,0l.25.07,5.1,1.57a6.57,6.57,0,0,1,1.74.81.71.71,0,0,1,.14.1,6.31,6.31,0,0,1,2.1,2.48c2.07,4.44,3.29,11.46,3.29,11.46l7.23-10.69Z",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1202.5,132V122",
    transform: "translate(1 -13.33)"
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1199.23,109.56c-.72,1.7-1.87,2.75-3.72,2.24s-4-2.71-3.51-4.72a1.22,1.22,0,0,1,.27,0l.24.07,4.91,1.51a6.09,6.09,0,0,1,1.67.79A.49.49,0,0,1,1199.23,109.56Z",
    transform: "translate(1 -13.33)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1184.88,107.54l-8.26,6-1.12-1.31-4.65,4.32.63.7,1.91,2.08a2.92,2.92,0,0,0,2,1,2.86,2.86,0,0,0,2.1-.73l9.66-9.33Z",
    transform: "translate(1 -13.33)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1187.15,110.24l4-2.49s-.52-3-3-2.94a3.15,3.15,0,0,0-2.39,1.43l-.88,1.3Z",
    transform: "translate(1 -13.33)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M868.4,169.63a13.6,13.6,0,0,0-25.68,6.25",
    transform: "translate(1 -13.33)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M835,169.52a13.59,13.59,0,0,0-25.66,6.25",
    transform: "translate(1 -13.33)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M809.3,175.88a7.89,7.89,0,1,0-15.77,0",
    transform: "translate(1 -13.33)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M846,167.07a9.59,9.59,0,0,0-13.38,8.81",
    transform: "translate(1 -13.33)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M823.5,166.5v8.37l4.09-4.09",
    transform: "translate(1 -13.33)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M933,140.44l18.52,29.64-5.1,2.86L933,154.24Z",
    transform: "translate(1 -13.33)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M952.3,175.76c0-.68-1-3.76-.39-3.76h4.16a3.76,3.76,0,0,1,3.77,3.76",
    transform: "translate(1 -13.33)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M912.08,154.52l-16.39-8.44a7.68,7.68,0,0,0-9.54,2.07l-15.77,20,6.87,5.08,15.51-14.54L903,166l11.7-5.1Z",
    transform: "translate(1 -13.33)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M929.7,138.66l1.53-5.84,1.11-6.55-6.4-2.44-4.47.42s-3,2.79-1.38,9.07,3.62,9.13,3.62,9.13Z",
    transform: "translate(1 -13.33)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M923.5,176.5h16",
    transform: "translate(1 -13.33)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M951.26,169.85,955,176h-5.26l-2.6-3.86Z",
    transform: "translate(1 -13.33)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M849.5,176.5h37",
    transform: "translate(1 -13.33)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M920.35,176H893a4.44,4.44,0,0,1-1.25-8.71l22.9-6.68,9.61,11.15a2.56,2.56,0,0,1-2,4.24Z",
    transform: "translate(1 -13.33)"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M936.22,150.38c-.32-7.38-4.69-12.49-8.17-12.49a8.63,8.63,0,0,0-5.39,1.67l-.54,1.44h-6.57s-3.33,8.77-5.29,13.38-2,9.33,1.26,9.33a7.37,7.37,0,0,0,3.24-.94,21,21,0,0,0,7.16,13.66C936.64,176.43,936.55,157.76,936.22,150.38Z",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M913.09,164.27s2.81-1.32,16.82-13.65Z",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M913.09,164.27s2.81-1.32,16.82-13.65",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M922.71,137.44l-4.5,14.71Z",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M922.71,137.44l-4.5,14.71",
    transform: "translate(1 -13.33)"
  }))), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M929,119.29a8.08,8.08,0,0,0-7.62,3.49,1.84,1.84,0,0,0,.79,2.7l1.3.56a5.34,5.34,0,0,1,3.07,3.5l.28,1,.36.06a2.73,2.73,0,0,1,.53-1.51,2.11,2.11,0,0,1,2.83-.76,1.71,1.71,0,0,1,.56,1.46c0,.9-.76,1.6-.74,2.49a6.54,6.54,0,0,0,.33,1.64c0,.07.27,1,.25,1A8.07,8.07,0,0,0,929,119.34Z",
    transform: "translate(1 -13.33)"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M919.66,131.17l.33,1.91a1.65,1.65,0,0,0,1.87,1.23l4.06-.58a1.09,1.09,0,0,1,1.14.84,1.11,1.11,0,0,1-.53,1.22l-3.26,1.78L922.12,141h-5.5l.71-5.24a7.78,7.78,0,0,1,2-4.27Z",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M919,129.91l.52,3a2,2,0,0,0,2,1.67l3.85-.4c.54,0,1.07-.12,1.21.41h0c.11.48-.42.75-.86,1l-2.82,1.52-1.74,5.16",
    transform: "translate(1 -13.33)"
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M859.25,173.26a1.38,1.38,0,0,0,.25,2.74l9.9.05a3.59,3.59,0,0,0,2.55-1l3.55-3.46-5.12-3.8-3.58,4.09Z",
    transform: "translate(1 -13.33)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M172.45,50.22a4,4,0,0,0,8,0",
    transform: "translate(1 -13.33)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M176.5,41.5V33.65a12.5,12.5,0,1,1,25-.17v106",
    transform: "translate(1 -13.33)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M192.35,175.62l1.58-30.16a7.62,7.62,0,0,1,7.62-7.24h0a7.64,7.64,0,0,1,7.63,7.24l1.57,30.16",
    transform: "translate(1 -13.33)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M186.35,50.5H166.57a9.06,9.06,0,0,1,6.53-8.68,8.75,8.75,0,0,1,2.44-.32h1.8a9,9,0,0,1,9,9h0Z",
    transform: "translate(1 -13.33)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M303,62h24",
    transform: "translate(1 -13.33)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M312.67,63.43c-.56.95-.12,2.09.19,3.16,2,6.9,13,27.53,13,27.53A14.19,14.19,0,0,0,327.77,93c1.46-1,3.07-2.54,2.53-3.62l-13.81-23a4.72,4.72,0,0,1,0-2.88l.6-1.91a1.3,1.3,0,0,0-.18-1.05A1.26,1.26,0,0,0,316,60h-1.11a1.62,1.62,0,0,0-1.32.87Z",
    transform: "translate(1 -13.33)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M279.65,92.24l.55-.49a3,3,0,0,1,2-.75h3.51a1.37,1.37,0,0,1,1.18.69,1.35,1.35,0,0,1,0,1.36l-1.31,2.27a1.37,1.37,0,0,1-1.18.68h-2.78l-1.48-.42-.47-3.34",
    transform: "translate(1 -13.33)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M254.2,96.61l25.44-4.84.47,3.35L257,102.85Z",
    transform: "translate(1 -13.33)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M255.82,99.06l-.37-5.24,3-2.62a4.49,4.49,0,0,0,1.36-4.62,7.88,7.88,0,0,0-3.22-4.43l-6.11,8.24L250.15,99Z",
    transform: "translate(1 -13.33)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M233.93,119.35c-3.86-1-6.15,0-7.35,1.6-1.9,2.53,2,6,2,6",
    transform: "translate(1 -13.33)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M328.82,18.32,231.88,175.5",
    transform: "translate(1 -13.33)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M289,84h26",
    transform: "translate(1 -13.33)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M277,103h26",
    transform: "translate(1 -13.33)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M266,122h26",
    transform: "translate(1 -13.33)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M253,142h26",
    transform: "translate(1 -13.33)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M242,161h25",
    transform: "translate(1 -13.33)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M207.5,175.5h16",
    transform: "translate(1 -13.33)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M231.5,175.5h17",
    transform: "translate(1 -13.33)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M258.5,175.5h33",
    transform: "translate(1 -13.33)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M261,154.78l0-9.78H254.5l1.67,13.08,5.31.53,3.89-1Z",
    transform: "translate(1 -13.33)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M234.19,130.82l-13.4,27.34,3-.66,16.47-23.34A12.33,12.33,0,0,1,234.19,130.82Z",
    transform: "translate(1 -13.33)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M216.64,174.81l-2.35-1.45-1.42.4a5.66,5.66,0,0,1-1.64.24h-4.92a1.38,1.38,0,0,0,1.24,2h8.51C216.67,176,217.17,175.13,216.64,174.81Z",
    transform: "translate(1 -13.33)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M267,158.81l-2.35-1.45-1.42.41a6.13,6.13,0,0,1-1.64.23H256.7a1.41,1.41,0,0,0,.07,1.35,1.39,1.39,0,0,0,1.17.65h8.51a.74.74,0,0,0,.59-1.19Z",
    transform: "translate(1 -13.33)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M219,162h-7.28l-5.67,11.29-.36.71h5.45a6.56,6.56,0,0,0,1.82-.26l1.58-.45L212,171.7Z",
    transform: "translate(1 -13.33)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M260.45,136.42a7.5,7.5,0,0,0-3.36-6.52c-3.44-2.28-8.85-5.82-13.65-8.85-3.88-2.43-6.93-2-9-1a8.81,8.81,0,0,0-3.88,4l-19,37.93h9.29l19.27-27.32a39.46,39.46,0,0,0,12.19,3l.78,7.34h7.77Z",
    transform: "translate(1 -13.33)"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M242,135.4s-9.45-2.78-9.66-8.65",
    transform: "translate(1 -13.33)"
  }))), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M210.7,162l1.51-3h12.15l-2.12,3Z",
    transform: "translate(1 -13.33)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M222.46,159l1.28-1.82L215.66,159Z",
    transform: "translate(1 -13.33)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M253.47,145l-.28-3h9.64l-.45,3Z",
    transform: "translate(1 -13.33)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M261.4,142l0-1.82L255.78,142Z",
    transform: "translate(1 -13.33)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M211.76,162H219l-1.48,2Z",
    transform: "translate(1 -13.33)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M254.54,145H261v2.49Z",
    transform: "translate(1 -13.33)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M234.63,119.91s1.25.38,5.6,1.59a23.38,23.38,0,0,0,7.2,1l-1.49-3.88-5.71-3.2.2-8-2.08,4a7.69,7.69,0,0,1-.93,1.46,19.25,19.25,0,0,1-5,4.21l-4.48,2.63a7.84,7.84,0,0,1,5.66-.17",
    transform: "translate(1 -13.33)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M247.47,122.53s2.32-5.22,5-7.9,5.29-2.1,7.8-5.41-4.42-11.54-4.42-11.54a10.56,10.56,0,0,1-5.71-.23l-8.35,6.31A60.37,60.37,0,0,1,234,119.35Z",
    transform: "translate(1 -13.33)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M287,100h-1a2,2,0,0,0-2,2v2.09a1.5,1.5,0,0,1-.95,1.42l-13.22,4.61-10.17-9.22c-1.63-1.53-4.31-2.07-5.9-.47a4.46,4.46,0,0,0-1.25,3.32,4.37,4.37,0,0,0,1.59,3.17l13.14,10.68a2.47,2.47,0,0,0,2.91.18L287,106.5a4.56,4.56,0,0,0,2-3.79V102a2,2,0,0,0-.59-1.44A1.85,1.85,0,0,0,287,100Z",
    transform: "translate(1 -13.33)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M257.91,79.66a3.91,3.91,0,1,0-7.81,0,3.72,3.72,0,0,0,.08.74c-1.35.8-4.52,3.19-3,7.48A15.83,15.83,0,0,0,237,94.8c-4.13,6.13.64,10.49.64,10.49s6.51,4.65,10.83-1.71a50.43,50.43,0,0,0,6.21-13.3s1.81-2.52,1-4.08c-.65-1.24.11-2.66.72-3.48A4.36,4.36,0,0,0,257.91,79.66Z",
    transform: "translate(1 -13.33)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-45",
    cx: 255.02,
    cy: 88.35,
    rx: 1.16,
    ry: 1.43,
    transform: "translate(107.81 300.57) rotate(-75.8)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M284.14,92.09l-2.47,1.42.72-2.51h2.27Z",
    transform: "translate(1 -13.33)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M236.83,117.77a13.32,13.32,0,0,0,12-5",
    transform: "translate(1 -13.33)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M355.51,18.32,258.38,175.5",
    transform: "translate(1 -13.33)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M315,41h27",
    transform: "translate(1 -13.33)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M364,175.88a7.89,7.89,0,0,1,15.78,0",
    transform: "translate(1 -13.33)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M336.62,92.27l1.83-4.13a8.26,8.26,0,0,1,2.91-3.5l1.27-.87,2.42,2.9c1,1.14,3,3.18,2.61,4.61l-1.28,2.64-3.8,3.53Z",
    transform: "translate(1 -13.33)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M330.29,89.19,335.23,100l-4.94,9.2s-3.17-1.61-8.93-14.88Z",
    transform: "translate(1 -13.33)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M312.5,175.5h23",
    transform: "translate(1 -13.33)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M359.5,175.5h23",
    transform: "translate(1 -13.33)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M338,136.39c-2.11-4.29-4.18-9-6.16-14.14A67.1,67.1,0,0,0,316.93,167h7.63C326.2,158.5,329.88,145.86,338,136.39Z",
    transform: "translate(1 -13.33)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M324.56,167H318.3c.05,1.28.11,2.49.23,4h5.4C324.11,169.62,324.3,168.41,324.56,167Z",
    transform: "translate(1 -13.33)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M367.74,167h-7.11c1.65,1.92,2.87,3.08,3.49,4h6C369.3,169.5,368.51,168.29,367.74,167Z",
    transform: "translate(1 -13.33)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.92,124.75s2.85-.13,2.17-4c-.59-3.35-2.53-3.36-3.42-8.31s-2.18,7.17-2.18,7.17Z",
    transform: "translate(1 -13.33)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 335.23,
    cy: 91.77,
    rx: 5.15,
    ry: 1.92,
    transform: "translate(0.03 166.58) rotate(-30)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M338,136.39A135.34,135.34,0,0,0,358.11,167h9.63c-14.23-22.26-18.82-42.34-18.82-42.34-9.47-4.46-17.09-2.4-17.09-2.4l8.29,11.84C339.38,134.86,338.67,135.62,338,136.39Z",
    transform: "translate(1 -13.33)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.12,134.17l-8.29-11.83q3,7.71,6.16,14.15C338.67,135.71,339.38,134.94,340.12,134.17Z",
    transform: "translate(1 -13.33)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M325.6,162.16l-.44,1.84h-5.83Z",
    transform: "translate(1 -13.33)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M325.1,167l.69-3h-9.61l.59,3Z",
    transform: "translate(1 -13.33)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M364.83,162.16l1.1,1.84h-6Z",
    transform: "translate(1 -13.33)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M368.59,167,367,164H354.68l2.81,3Z",
    transform: "translate(1 -13.33)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M360.63,167l8.15,1.61-1-1.61Z",
    transform: "translate(1 -13.33)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M318.3,167l6,1.43.26-1.43Z",
    transform: "translate(1 -13.33)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M339.69,89.19,331.34,67.1a4.06,4.06,0,0,1,.27-3.45c.16-.27,1.13-1.73,1.22-1.88a2.19,2.19,0,0,0-.79-3l-3.07,5-.26.42a4,4,0,0,0-.42,3.16c2,6.9,6.92,26.54,6.92,26.54a11.92,11.92,0,0,0,1.93-1.11C338.61,91.79,340.23,90.27,339.69,89.19Z",
    transform: "translate(1 -13.33)"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.92,124.75l-17.09-2.41s-6-14.3.56-23.78l-1.61-4.17,8.86-5.3s8,10.12,9.28,35.67",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M338,113.78a14.54,14.54,0,0,0,8.53,6.33",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M334.64,105.71l-3.31-8.47",
    transform: "translate(1 -13.33)"
  }))), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M351,86.81l-.5-1.54a3.12,3.12,0,0,0-2.9-2.27h-.26a3.18,3.18,0,0,1-2.28-1l-.87-.91a1.62,1.62,0,0,0-2.74.84l-1.23,3.67s.45-.41.6-.53c.42-.33,1.76-1.23,1.76-1.23l1.64,2.59a3.15,3.15,0,0,1,.54,2.38l-.27,1.55.1-.06a1.59,1.59,0,0,1,1.77,0,1.61,1.61,0,0,1,.68,1.63,1.59,1.59,0,0,1-1.24,1.26,2.07,2.07,0,0,1-1.07.15l-1.62,2.39.7,1.78L349,94.33A7,7,0,0,0,351,86.81Z",
    transform: "translate(1 -13.33)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-63",
    cx: 325.84,
    cy: 91.76,
    rx: 5.15,
    ry: 1.92,
    transform: "translate(-1.23 161.88) rotate(-30)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.12,175c-.87-1.66-1.14-2.37-2-4h-5.94c-1.67,1-4.81,2.26-6.69,3.59a1,1,0,0,0-.33.41h15Z",
    transform: "translate(1 -13.33)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M358.15,177h13c.39-.64.74-.84.94-1.17s.22-.73.06-.83H357.05c-.14.12-.09.53.13.85A10.48,10.48,0,0,1,358.15,177Z",
    transform: "translate(1 -13.33)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M311.26,177h11.22c.47-.62.87-1,.91-1.46a1.74,1.74,0,0,1,.08-.54H310.7c-.31,0-.43.4-.31.77A11.79,11.79,0,0,0,311.26,177Z",
    transform: "translate(1 -13.33)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324,171h-5.41l-7.82,4h12.77C323.54,174.06,323.7,172.68,324,171Z",
    transform: "translate(1 -13.33)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M377.45,169.63a13.6,13.6,0,0,1,25.67,6.25",
    transform: "translate(1 -13.33)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M410.88,169.52a13.6,13.6,0,0,1,25.67,6.25",
    transform: "translate(1 -13.33)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M436.55,175.88a7.89,7.89,0,1,1,15.77,0",
    transform: "translate(1 -13.33)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M399.87,167.07a9.59,9.59,0,0,1,13.36,8.81",
    transform: "translate(1 -13.33)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M379.5,129.5v37",
    transform: "translate(1 -13.33)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M390.5,166.5v8.37l-4.09-4.09",
    transform: "translate(1 -13.33)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M421.5,166.5v8.37l-4.09-4.09",
    transform: "translate(1 -13.33)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M379.89,146.52l6.5-6.5",
    transform: "translate(1 -13.33)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M379.77,137.47l-4.62-4.62",
    transform: "translate(1 -13.33)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M390.29,171.94l3-3",
    transform: "translate(1 -13.33)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 370.5,
    y: 102.43,
    width: 20,
    height: 38.8,
    rx: 9.97
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M94,147h75.55a2.65,2.65,0,0,0,2.55-1.71,2.55,2.55,0,0,0-2.59-3.29H94",
    transform: "translate(1 -13.33)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M93.5,147.5h76a2.62,2.62,0,0,0,2.72-2.5h0a2.62,2.62,0,0,0-2.72-2.5h-76",
    transform: "translate(1 -13.33)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M173.5,175.5h14",
    transform: "translate(1 -13.33)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M58.5,175.5h107",
    transform: "translate(1 -13.33)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M139.22,147.5h-76A2.62,2.62,0,0,1,60.5,145h0a2.62,2.62,0,0,1,2.72-2.5h76a2.61,2.61,0,0,1,2.71,2.5h0A2.61,2.61,0,0,1,139.22,147.5Z",
    transform: "translate(1 -13.33)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M174,175.62l-5.79-28",
    transform: "translate(1 -13.33)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M90.81,116.38l.43-2.13",
    transform: "translate(1 -13.33)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M88.45,128.24l1-4.94",
    transform: "translate(1 -13.33)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M85.66,142.24l1.57-7.88",
    transform: "translate(1 -13.33)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M167,116.38l.42-2.13",
    transform: "translate(1 -13.33)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M164.64,128.24l1-4.94",
    transform: "translate(1 -13.33)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M161.86,142.24l1.56-7.88",
    transform: "translate(1 -13.33)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M143.11,147.67l5.43,28",
    transform: "translate(1 -13.33)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M58.05,174.91l5.42-27.24",
    transform: "translate(1 -13.33)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M174.5,122.5H85a2.61,2.61,0,0,1-2.71-2.5h0A2.61,2.61,0,0,1,85,117.5H174.5a2.62,2.62,0,0,1,2.72,2.5h0A2.62,2.62,0,0,1,174.5,122.5Z",
    transform: "translate(1 -13.33)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M170.92,133.5H81.4a2.62,2.62,0,0,1-2.72-2.5h0a2.62,2.62,0,0,1,2.72-2.5h89.52a2.62,2.62,0,0,1,2.72,2.5h0A2.62,2.62,0,0,1,170.92,133.5Z",
    transform: "translate(1 -13.33)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M82.76,122.55A31.78,31.78,0,0,1,60.24,122",
    transform: "translate(1 -13.33)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M41.09,98a31.62,31.62,0,1,1,51.57,19",
    transform: "translate(1 -13.33)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M72.5,147.5v27",
    transform: "translate(1 -13.33)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M72.5,80.5v62",
    transform: "translate(1 -13.33)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M72.27,103.39,90.64,85",
    transform: "translate(1 -13.33)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M72.08,116,59.73,103.65",
    transform: "translate(1 -13.33)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M59.5,110.5h7",
    transform: "translate(1 -13.33)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M81.5,94.5h10",
    transform: "translate(1 -13.33)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M86.5,89.5v-6",
    transform: "translate(1 -13.33)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M72.27,93.91,58.53,80.17",
    transform: "translate(1 -13.33)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 68.73,
    cy: 63.74,
    r: 2
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 55.1,
    cy: 85.29,
    r: 2
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 89.04,
    cy: 94.66,
    r: 2
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 46.32,
    cy: 117.91,
    r: 2
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 33.06,
    cy: 111.07,
    r: 27.66
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M31.5,112.5v53",
    transform: "translate(1 -13.33)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M31.63,130.75l10.31-10.3",
    transform: "translate(1 -13.33)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M31.44,140.65l-7.32-7.33",
    transform: "translate(1 -13.33)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M31.44,124.59l-7.32-7.33",
    transform: "translate(1 -13.33)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M13,170.63a13.59,13.59,0,0,1,25.66,6.25",
    transform: "translate(1 -13.33)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-.5,176.88a7.89,7.89,0,1,1,15.77,0",
    transform: "translate(1 -13.33)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M25.5,167.5v8.37l-4.09-4.09",
    transform: "translate(1 -13.33)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M25.78,172.94l3-3",
    transform: "translate(1 -13.33)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M92.66,147.67l-5.43,27.24",
    transform: "translate(1 -13.33)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M123.94,112.13c2.54,0,4.94-4.13,4.94-4.13H126v-2h-3v1h-4C119.47,110.38,121.53,112.12,123.94,112.13Z",
    transform: "translate(1 -13.33)"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M128.88,107c-.32,3.12-2.35,5-4.79,5s-5-4-5-4h-3.29a16.68,16.68,0,0,0-7.22,2.44,7.65,7.65,0,0,0,0,12.63,7.15,7.15,0,0,0,3.19,1.12s.36,5.32-1.15,7.81h17.6l11.67-25Z",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M111,114.36s2.24,6.4,10.86,6",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M121.83,125a27.87,27.87,0,0,1-13-1.07",
    transform: "translate(1 -13.33)"
  }))), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M125,108h5.49s2.17-15.79-7.16-15.79-9.09,11.64-9.09,18.63c0,.54.06,3.71.16,4.16H123V98.35a.35.35,0,0,1,.34-.35h3.93L125,105.88Z",
    transform: "translate(1 -13.33)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M123,106h2.23a2.65,2.65,0,0,0,2.39-1.39,6.38,6.38,0,0,0,.54-3.25c-.11-2.64-.41-3.2-.54-3.32l-.11,0h-4.32a.21.21,0,0,0-.19.19Z",
    transform: "translate(1 -13.33)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M125,107.23V106h-2.11Z",
    transform: "translate(1 -13.33)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.61,132s-7.81.21-10.46,7-2.63,14.39-2.63,22h6.54s.42-10.36,2.25-14.5c0,0,1.37-5.25,12.73-5.25L127.3,132Z",
    transform: "translate(1 -13.33)"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.49,132s-7.8.21-10.45,7-2.63,14.39-2.63,22H94s.41-10.36,2.25-14.5c0,0,2.49-7.25,12.72-5.25l8.27-9.25Z",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M111.27,131.53a10.07,10.07,0,0,0-3,.44c-2.43.76-6.88,2.68-8.69,7.36-2.69,6.86-2.69,14.53-2.69,22.17h6.59s.43-10.46,2.29-14.64c0,0,2.5-7.32,12.83-5.3l7.9-10.06Z",
    transform: "translate(1 -13.33)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 88,
    y: 147.67,
    width: 5,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 98,
    y: 147.67,
    width: 5,
    height: 2
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M102,163v2.08a2.82,2.82,0,0,1-.82,2L97,171.23a1.1,1.1,0,0,1-1.36.13,1.13,1.13,0,0,1-.45-1.31l1.84-5.4V163Z",
    transform: "translate(1 -13.33)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M92,163H87v1.65l-1.84,5.4a1,1,0,0,0,.27,1.16L92,164.87Z",
    transform: "translate(1 -13.33)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M86.88,171.56l4.28-4.15a2.8,2.8,0,0,0,.84-2v-.21l-6.69,6.35A1.13,1.13,0,0,0,86.88,171.56Z",
    transform: "translate(1 -13.33)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M96.88,171.56l4.28-4.15a2.8,2.8,0,0,0,.84-2v-.21l-6.69,6.35A1.13,1.13,0,0,0,96.88,171.56Z",
    transform: "translate(1 -13.33)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M147.78,106s-2-.41-2.45-3.28a8.75,8.75,0,0,0-1.39-1.26,2.61,2.61,0,0,0,.31-.8c.15-1-.24-1.81-.88-1.92s-1.29.58-1.45,1.53a12,12,0,0,0-6.63-.91s.73,8.7,6,6l.3.67a1,1,0,0,1-.64,1.3,17.23,17.23,0,0,0-3.33,1.21,8.34,8.34,0,0,0,13.23-1.92A12.78,12.78,0,0,0,147.78,106Z",
    transform: "translate(1 -13.33)"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.91,107.74a8.19,8.19,0,0,1-13,1.89c-2.58,1.24-5.43,3.54-5.89,7.66V132h-5.55s-6.64,1.49-8.77,7.94-2.39,13.22-2.39,18.06h22.19s-.48-9.67,3.58-16h6.45c6.3,0,9.27-8.42,10.11-13.29C158.89,121.41,158.88,110.44,150.91,107.74Z",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M144.48,136.44S140,142.61,138.86,147",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M156.43,110.93a14,14,0,0,1,.49,11.57h-8.14a22,22,0,0,0,.85-6.19",
    transform: "translate(1 -13.33)"
  }))), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M141.3,105.36l2.51-1.4-2.16,2.22Z",
    transform: "translate(1 -13.33)"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.18,128.54l1.88,2.75c7.86,0,11.48-6.52,12.32-8.29h-5.6C147.78,127.24,141.18,128.54,141.18,128.54Z",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M149.11,122.91l6.27,1.56.67-2.45-6.08-.71Z",
    transform: "translate(1 -13.33)"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 146.77,
    cy: 81.91,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M139.8,94.24s5.46.28,7.3,5.05l-3.65,1.54L138.61,94Z",
    transform: "translate(1 -13.33)"
  }))), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M145,98.29a6.82,6.82,0,0,0-1.64-2.81,4.54,4.54,0,0,0-3.68-1.21,5.27,5.27,0,0,0-4.63,3.92A4,4,0,0,0,135,99v.35s4.07-.09,6,.77l.59.29a.38.38,0,0,1,0-.15c.16-1,.81-1.64,1.45-1.53s1,1,.87,1.92a2.39,2.39,0,0,1-.38,1c.85.6,1.46,1.1,1.46,1.1S146.08,101.44,145,98.29Z",
    transform: "translate(1 -13.33)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145,132h-19.2a2.27,2.27,0,0,1-2-1.17l-7.59-13.61a.82.82,0,0,1,.72-1.22h17.79a2.26,2.26,0,0,1,2,1.16Z",
    transform: "translate(1 -13.33)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 139,
    y: 117.67,
    width: 12,
    height: 1
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M128.82,158h-1.3c.28-3.63-.09,0-.09,0h-6.7c.13,4.67,1.29,9.48,2.07,14.43a1.48,1.48,0,0,1-.94,1.51l-3.43,1.49a.82.82,0,0,0,.32,1.57H131a1.49,1.49,0,0,0,1.48-1.48,113,113,0,0,1,2.1-18.52Z",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M135.5,162.35,120,159.84V157h15.63Z",
    transform: "translate(1 -13.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M123.45,177.25a1.06,1.06,0,0,1-.26-2l3.45-1.47a1.54,1.54,0,0,0,.94-1.51,135.43,135.43,0,0,1,0-14.53",
    transform: "translate(1 -13.33)"
  }))), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M158.3,112c.56,1.53.62,3.06-.9,3.62a2.94,2.94,0,0,1-2-5.52C156.9,109.52,157.76,110.46,158.3,112Z",
    transform: "translate(1 -13.33)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M162.06,174.6l-7.8-39.11a3.91,3.91,0,0,1,3.93-4.9h0a6.27,6.27,0,0,1,5.88,4.9",
    transform: "translate(1 -13.33)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M162.13,174.92l-.2-1",
    transform: "translate(1 -13.33)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUntitled3);
export default __webpack_public_path__ + "static/media/Untitled-3.86d5030b6135455942c14f77bb844524.svg";
export { ForwardRef as ReactComponent };